import { useEffect, useState, useMemo } from 'react'
import { Panel } from '@ui5/webcomponents-react'
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import Box from '@mui/material/Box'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import Container from '@mui/material/Container';
import { useTableStyles } from '../utils/tableStyles'
import { useTheme } from '../utils/ThemeContext'
import '../styles/MaterialTableStyles.css';

const MEMBERS_PAGE_SIZE_KEY = 'members_pageSize';

const Members = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const { defaultTableConfig, panelBackgroundColor } = useTableStyles();
  const [playerData, setPlayerData] = useState([])
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)
  // eslint-disable-next-line no-unused-vars
  const [currentYear, setCurrentYear] = useState(process.env.REACT_APP_CURRENT_YEAR)
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: parseInt(sessionStorage.getItem(MEMBERS_PAGE_SIZE_KEY) || '10', 10),
  })

  useEffect(() => {
    setLoading(true)
    getPlayers()
  }, [])

  async function getPlayers() {
    await axios.get("api/players/read.php?option=Active")
    .then((response) => {
      setPlayerData(response.data.records)
    }).catch((error) =>{
      setError(error)
      console.error("Error fetching data: ", error)
    }).finally(() => {
      setLoading(false)
    })
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const columns = useMemo(
    () => [
              {
                header: 'Name',
                accessorKey: 'fullName',
                size: 200,
                Cell: ({renderedCellValue, row}) => {
                  return(
                    <>
                      <Link style={{textDecoration: "none", color: theme.primary, fontWeight: 'bold'}} to={{pathname: '/memberstats', search: `?id=${row.original.playerID}&year=${currentYear}`}}>
                          {renderedCellValue}
                      </Link>
                    </>
                  )
                }
              },
              {
                header: 'Handicap',
                accessorKey: 'handicap',
                size: 100
              },

            ],
    [theme, currentYear]
    );

 const table = useMaterialReactTable({
    columns,
    data: playerData,
    enableColumnFilters: false,
    enableHiding: false,
    enableColumnPinning: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnActions: false,
    state: { isLoading: loading, pagination },
    onPaginationChange: (updater) => {
      setPagination((prev) => {
        const next = typeof updater === 'function' ? updater(prev) : updater;
        sessionStorage.setItem(MEMBERS_PAGE_SIZE_KEY, String(next.pageSize));
        return next;
      });
    },
    ...defaultTableConfig,
    muiTableBodyRowProps: ({ row }) => ({
      onClick: () => navigate({ pathname: '/memberstats', search: `?id=${row.original.playerID}&year=${currentYear}` }),
      sx: { cursor: 'pointer' },
    }),
  });

 return(
    <>
    <Box display="inherit">
        <Panel fixed stickyHeader style={{backgroundColor: panelBackgroundColor}} headerText={"Members"}>
          <Container>
          <MaterialReactTable table={table} />
          </Container>
        </Panel>
    </Box>
    </>
    )
  }

  export default Members;
